import React from "react";
import { Link } from "react-router-dom";
import { authHeader, handleResponse } from '_helpers';
import { authenticationService } from '_services';

// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip
} from "reactstrap";

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const currentUser = authenticationService.currentUserValue;
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} expand="lg" color="info">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand
              href="/home"
              id="navbar-brand"
            >
              <img
                              alt="โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง"
                              src={require("assets/img/logo1.png")}
                              style={{maxWidth:'40px'}}
              ></img>
            </NavbarBrand>
            <UncontrolledTooltip target="#navbar-brand">
              โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
            </UncontrolledTooltip>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
                      <Nav navbar style={{ fontSize: '1.5em' }}>
                          <NavItem>
                              {
                                  (currentUser != "") ?
                                      <NavLink to="/admin" tag={Link}>
                                          <i className="fas fa-home"></i> หน้าแรก
                                    </NavLink>
                                              :
                                              <NavLink to="/home" tag={Link}>
                                                  <i className="fas fa-home"></i> หน้าแรก
                                    </NavLink>
                              }
                          </NavItem>
                          <NavItem>
                              <NavLink to="/tele" tag={Link}>
                                  <i className="fas fa-calendar-check"></i> นัดหมาย
                </NavLink>
                          </NavItem>

                          <UncontrolledDropdown nav>
                              <DropdownToggle
                                  caret
                                  color="default"
                                  href="#pablo"
                                  nav

                                  onClick={e => e.preventDefault()}
                              >
                                  <i className="fas fa-user-cog mr-1"></i>
                                  <span className="d-inline d-sm-inline d-md-inline d-lg-none"> ข้อมูลส่วนตัว</span>
                              </DropdownToggle>

                              <DropdownMenu right style={{ overflow: 'hidden' }}>
                                  <DropdownItem to="/profile" tag={Link}>
                                      <i className="fa fa-user mr-1"></i>
                                      ข้อมูลส่วนตัว
                  </DropdownItem>
                                  <DropdownItem to="/logout" tag={Link}>
                                      <i className="fas fa-sign-out-alt  mr-1"></i>
                                      ออกจากระบบ
                  </DropdownItem>
                              </DropdownMenu>
                          </UncontrolledDropdown>

                          <UncontrolledDropdown nav>
                              <DropdownToggle
                                  id="social-network"
                                  caret
                                  color="default"
                                  href="#pablo"
                                  nav
                                  onClick={e => e.preventDefault()}
                              >
                                  <i className="far fa-thumbs-up"></i>
                                  <span className="d-inline d-sm-inline d-md-inline d-lg-none"> Social Network</span>
                              </DropdownToggle>

                              <DropdownMenu right style={{ overflow: 'hidden' }}>
                                  <DropdownItem to="https://www.facebook.com/trangskin" target="_blank" tag={Link}>
                                      <i className="fab fa-facebook-square"></i>
                                      &nbsp; Like us on Facebook
                        </DropdownItem>
                                  <DropdownItem to="https://www.youtube.com/channel/UCpwQPYC7vbgbFJsYo4LStAw" target="_blank" tag={Link}>
                                      <i className="fab fa-youtube"></i>
                                      &nbsp; Subscribe us on Youtube
                        </DropdownItem>
                                  <DropdownItem to="http://www.trangskin.go.th" target="_blank" tag={Link}>
                                      <i className="fab fa-internet-explorer"></i>
                                      &nbsp; More information on trangskin.com
                        </DropdownItem>
                              </DropdownMenu>
                              <UncontrolledTooltip target="#social-network">
                                  Social Network
                </UncontrolledTooltip>
                          </UncontrolledDropdown>
                      </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default IndexNavbar;
